<div class="component-container" class="{{ size }}" [ngClass]="{active: active}" (click)="toggle()">
    <div class="inner"></div>
</div>
